
import React, { useState } from 'react';
import LeadsCard from './LeadsCard';
import TotalSpentCard from './TotalSpentCard';
import CostPerLeadCard from './CostPerLeadCard';
import CallsAnsweredMetric from './CallsAnsweredMetric';
import ClosedDealsCard from './ClosedDealsCard';
import CloseRateCard from './CloseRateCard';
import GrossProfitCard from './GrossProfitCard';
import ROICard from './ROICard';
import { Separator } from '@/components/ui/separator';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface MobileMetricsGridProps {
  nonDisqualifiedLeads: number;
  totalSpent: number;
  costPerLead: number;
  callsAnsweredPercentage: number;
  closedDealsCount: number;
  grossProfit: number;
  roi: number;
  closeRate?: number;
  timeFrame?: string;
}

const MobileMetricsGrid: React.FC<MobileMetricsGridProps> = ({
  nonDisqualifiedLeads,
  totalSpent,
  costPerLead,
  callsAnsweredPercentage,
  closedDealsCount,
  grossProfit,
  roi,
  closeRate,
  timeFrame = 'Past 30 days'
}) => {
  // Determine if there are any leads for this timeframe
  const hasNoLeads = nonDisqualifiedLeads === 0;
  
  // Use state to control accordion with initial state empty (collapsed)
  const [accordionValue, setAccordionValue] = useState("");

  return (
    <div className="flex flex-col gap-6 mb-6">
      {/* Performance Metrics Section */}
      <div>
        <h3 className="text-lg font-medium mb-3 text-gray-700">Performance Metrics</h3>
        <div className="grid grid-cols-2 gap-4">
          <LeadsCard nonDisqualifiedLeads={nonDisqualifiedLeads} timeFrame={timeFrame} noData={hasNoLeads} />
          <CallsAnsweredMetric callsAnsweredPercentage={callsAnsweredPercentage} timeFrame={timeFrame} noData={hasNoLeads} />
          <TotalSpentCard totalSpent={totalSpent} timeFrame={timeFrame} noData={hasNoLeads} />
          <CostPerLeadCard costPerLead={costPerLead} timeFrame={timeFrame} noData={hasNoLeads} />
        </div>
      </div>
      
      {/* Divider */}
      <div className="px-0">
        <Separator className="my-1" />
      </div>
      
      {/* Profitability Metrics Section with Accordion */}
      <div>
        <Accordion 
          type="single" 
          collapsible 
          value={accordionValue} 
          onValueChange={setAccordionValue}
        >
          <AccordionItem value="profitability" className="border-none">
            <AccordionTrigger className="p-0 py-0 h-8 hover:no-underline">
              <div className="flex items-center w-full">
                <h3 className="text-lg font-medium text-gray-700 flex-grow text-left">Profitability Metrics</h3>
              </div>
            </AccordionTrigger>
            <AccordionContent className="pt-3 pb-0">
              <div className="grid grid-cols-2 gap-4">
                <ClosedDealsCard closedDealsCount={closedDealsCount} timeFrame={timeFrame} noData={hasNoLeads} />
                <CloseRateCard 
                  closedDealsCount={closedDealsCount} 
                  nonDisqualifiedLeads={nonDisqualifiedLeads} 
                  timeFrame={timeFrame}
                  noData={hasNoLeads}
                />
                <GrossProfitCard grossProfit={grossProfit} timeFrame={timeFrame} noData={hasNoLeads} />
                <ROICard roi={roi} timeFrame={timeFrame} noData={hasNoLeads} />
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default MobileMetricsGrid;
